export const INVITE_REASON_COPY = {
  front_rate_limited: 'Front rate limit, retry in a minute',
  crc_missing: 'Member has no assigned CRC',
  crc_front_unmatched: 'Assigned CRC has no matching Front teammate',
  crc_front_ambiguous: 'Assigned CRC matches more than one Front teammate',
  sender_name_missing: 'Assigned CRC has no Front display name',
  template_missing_body: 'Front template is missing a body',
  template_missing_subject: 'Front template is missing a subject',
  reply_missing_conversation: 'No parent Front thread to reply to',
  not_eligible: 'Member is not eligible for chase mail',
  not_kick_start: 'This step is not started by Invite',
  chase_started: 'Chase already started',
  already_sent: 'Already sent',
  sent: 'Sent',
  front_unreachable: 'Could not read Front before sending',
  funnel_inbox_unknown: 'Funnel inbox is not configured',
  send_failed_3x: 'Send failed three times',
  send_stuck_sending: 'Previous send was stuck',
  send_failed: 'Invite failed',
  member_replied: 'Member already replied',
  front_has_unlogged_outbound: 'Front has mail we did not send',
  app_send_missing_in_front: 'Previous send is missing in Front',
  front_mismatch: 'Front thread does not match this chase',
};

export function formatInviteReason(reason, detail) {
  const code = (reason || '').trim();
  const extra = (detail || '').trim();
  if (!code && !extra) return '';
  const label = INVITE_REASON_COPY[code] || (code || extra || 'Failed');
  if (extra && extra !== code && extra !== label) {
    return `${label}: ${extra}`;
  }
  return label;
}
